import { Portfolio, PortfolioBuilder, RiskAnalyticsDirector, SecurityDirector, WebUserDataConstants } from '@ddt-web/domain';
import * as get from 'lodash/get';

import { PerformanceReturnDirector } from './performance-return-director';

export class PortfolioDirector {
	// SHOULD BE UPDATED FOR THE THINGS USED (E.G. DESCRIPTION ETC) BUT EVERYTHING ELSE SHOULD BE REMOVED
	public construct(portfolioJson: any, portfolioBuilder?: PortfolioBuilder): Portfolio {
		return (portfolioBuilder ? portfolioBuilder : new PortfolioBuilder())
			.setApplications(['bfa']) // should ask backend to include this
			.setBaseModel(portfolioJson.baseModel)
			.setDescription(
				portfolioJson.modelPortfolio
					? portfolioJson.modelPortfolio.attributesByCodeMap
						? portfolioJson.modelPortfolio.attributesByCodeMap.model_portfolio_long_name
							? portfolioJson.modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation
							: null
						: null
					: portfolioJson.name ? portfolioJson.name : portfolioJson.description ? portfolioJson.description : null
			)

			.setFlags(portfolioJson.flags || {})
			.setOrigin('bfa')
			.setSubType(portfolioJson.subType ? portfolioJson.subType : portfolioJson.portfolioType ? portfolioJson.portfolioType : '')
			.setType(portfolioJson.type ? portfolioJson.type : WebUserDataConstants.TYPE.PORTFOLIO)
			.setUniqueId(
				portfolioJson.uniqueId
					? portfolioJson.uniqueId.toString()
					: portfolioJson.portfolioId ? portfolioJson.portfolioId.toString() : portfolioJson.id ? portfolioJson.id.toString() : null
			)
			.setDateLastModified(
				portfolioJson.portfolioType === WebUserDataConstants.SUBTYPE.MODEL_PORTFOLIO
					? Array.isArray(get(portfolioJson, 'modelPortfolio.analyticsByCodeMap.MPSREBAL.analyticValue', null))
						? get(portfolioJson, 'modelPortfolio.analyticsByCodeMap.MPSREBAL.analyticValue[1]', null)
						: get(portfolioJson, 'modelPortfolio.analyticsByCodeMap.MPSREBAL.analyticValue', null)
					: portfolioJson.dateLastModified
			)
			.setExpenseRatio(portfolioJson.analyticsMap)
			.setPortfolioId(portfolioJson.portfolioId)
			.setPerformanceReturns(new PerformanceReturnDirector().construct(portfolioJson))
			.setSecurities(
				portfolioJson.children && portfolioJson.children.length
					? portfolioJson.children.map(holding => {
						holding.parentPortfolioId = portfolioJson.portfolioId;
						return new SecurityDirector().construct(holding);
					})
					: null
			)
			.setRiskAnalytics(new RiskAnalyticsDirector().construct(portfolioJson))
			.setRiskScenarios(portfolioJson.riskData && portfolioJson.riskData.stressMap ? new Map<string, number>(Object.entries(portfolioJson.riskData.stressMap)) : null)
			.setYieldValue(portfolioJson.analyticsMap)
			.setLastModifyingUser(portfolioJson.updateUserId)
			.setCurrentUserIsOwner(portfolioJson.currentUserIsOwner)
			.setOwner(portfolioJson.userId)
			.setPerms(portfolioJson.allowedPermsForCurrentUser ? portfolioJson.allowedPermsForCurrentUser : [])
			.setBaseEngagementPortfolio(portfolioJson.baseEngagementPortfolio ? portfolioJson.baseEngagementPortfolio : null)
			.build();
	}
}
